import type { TempoStage } from '../types/models';
import { GAME_DURATION_SECONDS, TEMPO_STAGE_THRESHOLDS } from './constants';

function clampSeconds(timeLeft: number): number {
  if (!Number.isFinite(timeLeft)) return 0;
  return Math.max(TEMPO_STAGE_THRESHOLDS.finalMin, Math.min(GAME_DURATION_SECONDS, Math.floor(timeLeft)));
}

export function deriveTempoStage(timeLeft: number): TempoStage {
  const clamped = clampSeconds(timeLeft);

  if (clamped >= TEMPO_STAGE_THRESHOLDS.earlyMin) {
    return 'early';
  }

  if (clamped >= TEMPO_STAGE_THRESHOLDS.midMin) {
    return 'mid';
  }

  return 'final';
}

export function isFinalCountdown(timeLeft: number): boolean {
  return deriveTempoStage(timeLeft) === 'final';
}
